export enum GiftCardStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  CLOSED = "CLOSED",
}
